module.exports = __webpack_public_path__ + "img/notfound.d77a131e.webp";